import React from "react";
import StockOptions from "./StockOptions";
import "./dashboard.css";

export default function StockScreenerDashboard({ username, onLogout }) {
  return (
    <div className="terminal stock-user-dashboard">
      <header className="stock-user-header">
        <div>
          <strong>MintX Stock Derivatives</strong>
          <small>{username || "Stock_User"} · Stock Derivatives access</small>
        </div>
        <button onClick={onLogout}>Logout</button>
      </header>
      <StockOptions canManageOrb={false} />
    </div>
  );
}
